import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\ContributionController::show
* @see app/Http/Controllers/Creator/ContributionController.php:82
* @route '/app/creator/contributions/{contribution}'
*/
export const show = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/creator/contributions/{contribution}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\ContributionController::show
* @see app/Http/Controllers/Creator/ContributionController.php:82
* @route '/app/creator/contributions/{contribution}'
*/
show.url = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contribution: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { contribution: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            contribution: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contribution: typeof args.contribution === 'object'
        ? args.contribution.uuid
        : args.contribution,
    }

    return show.definition.url
            .replace('{contribution}', parsedArgs.contribution.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\ContributionController::show
* @see app/Http/Controllers/Creator/ContributionController.php:82
* @route '/app/creator/contributions/{contribution}'
*/
show.get = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::show
* @see app/Http/Controllers/Creator/ContributionController.php:82
* @route '/app/creator/contributions/{contribution}'
*/
show.head = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::show
* @see app/Http/Controllers/Creator/ContributionController.php:82
* @route '/app/creator/contributions/{contribution}'
*/
const showForm = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::show
* @see app/Http/Controllers/Creator/ContributionController.php:82
* @route '/app/creator/contributions/{contribution}'
*/
showForm.get = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::show
* @see app/Http/Controllers/Creator/ContributionController.php:82
* @route '/app/creator/contributions/{contribution}'
*/
showForm.head = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Creator\ContributionController::reply
* @see app/Http/Controllers/Creator/ContributionController.php:110
* @route '/app/creator/contributions/{contribution}/reply'
*/
export const reply = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

reply.definition = {
    methods: ["post"],
    url: '/app/creator/contributions/{contribution}/reply',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\ContributionController::reply
* @see app/Http/Controllers/Creator/ContributionController.php:110
* @route '/app/creator/contributions/{contribution}/reply'
*/
reply.url = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contribution: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { contribution: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            contribution: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contribution: typeof args.contribution === 'object'
        ? args.contribution.uuid
        : args.contribution,
    }

    return reply.definition.url
            .replace('{contribution}', parsedArgs.contribution.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\ContributionController::reply
* @see app/Http/Controllers/Creator/ContributionController.php:110
* @route '/app/creator/contributions/{contribution}/reply'
*/
reply.post = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::reply
* @see app/Http/Controllers/Creator/ContributionController.php:110
* @route '/app/creator/contributions/{contribution}/reply'
*/
const replyForm = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::reply
* @see app/Http/Controllers/Creator/ContributionController.php:110
* @route '/app/creator/contributions/{contribution}/reply'
*/
replyForm.post = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

reply.form = replyForm

const contributions = {
    show: Object.assign(show, show),
    reply: Object.assign(reply, reply),
}

export default contributions